import React from "react";
import { Printer, FileDown } from "lucide-react";

/**
 * PdfExportButton — triggers the browser's native print dialog which allows
 * users to "Save as PDF". A dedicated print stylesheet (see index.css) hides
 * chrome (header, chat, search) and prints the report content only.
 */
export default function PdfExportButton({ ticker, name }) {
  const filename = `${name || ticker || "股票研究報告"}_${ticker || ""}_AI研究報告`
    .replace(/\s+/g, "_")
    .replace(/[\\/:*?"<>|]/g, "");

  const handleClick = () => {
    const prevTitle = document.title;
    document.title = filename; // Chrome uses document.title as default PDF filename
    // Give the browser a tick to update the title before opening the dialog
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        document.title = prevTitle;
      }, 500);
    }, 20);
  };

  return (
    <section
      className="card-tactical p-6 sm:p-8 border-blue-500/30 bg-blue-500/[0.04] no-print"
      data-testid="pdf-export-section"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-blue-500/10 border border-blue-500/30 flex items-center justify-center flex-shrink-0">
            <FileDown className="w-5 h-5 text-blue-400" strokeWidth={1.6} />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-blue-400/80 font-mono mb-1">
              Export Report
            </div>
            <h3 className="text-lg font-semibold text-white">
              匯出完整 AI 研究報告
            </h3>
            <p className="text-xs text-zinc-400 mt-1 max-w-xl leading-relaxed">
              一鍵打開瀏覽器列印對話框，選擇「另存為 PDF」即可下載本頁完整報告
              （公司概況、財務圖表、優勢／風險、競爭對手、AI 綜合評分、完整報告）。
              自動隱藏搜尋列與 AI 對話面板。
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={handleClick}
          data-testid="pdf-export-btn"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-lg
                     bg-blue-500 hover:bg-blue-400 text-white text-sm font-semibold
                     shadow-lg shadow-blue-500/20 transition-all
                     active:scale-[0.98] whitespace-nowrap
                     focus:outline-none focus:ring-2 focus:ring-blue-400/50"
        >
          <Printer className="w-4 h-4" strokeWidth={2} />
          輸出成 PDF
        </button>
      </div>
    </section>
  );
}
